import React from "react";
import { Link } from "react-router-dom";
import { timeSince } from "../util/utility";
import { Button } from "./button";
import { SmallButton } from "./small-button";

interface IPodcastProps {
    id: string;
    title: string;
    category?: string;
    rating?: number;
    createdAt?: string;
    coverImage?: string;
}

export const Podcast: React.FC<IPodcastProps> = ({
    id,
    title,
    category,
    rating,
    createdAt,
    coverImage,
}) => (
    <Link to={`/podcasts/${id}`}>
        <div className="flex flex-col">
            <div className="m-5">
                <img
                    src={coverImage || "/images/podcast.jpeg"}
                    className="w-full h-full rounded-lg"
                ></img>
                <div className="p-5">
                    <h3 className="text-2xl">{title}</h3>
                    <span className="py-2 text-xs">
                        {timeSince(createdAt)}
                    </span>
                </div>
            </div>
            {/* <div className="ml-5">
                <h3 className="py-2 text-xl border-gray-400">
                    Category 💫 : {category}
                </h3>
                <h3 className="border-b py-2 text-xm border-gray-400">
                    Rating 💯 : {rating}
                </h3>
            </div> */}
        </div>
    </Link>
);
